import { createGlobalStyle } from "styled-components";


export const GlobalStyles=createGlobalStyle`
body{
    margin:0;
    padding:0;
    background:${({theme})=>theme.background};
    color:${({theme})=>theme.titleColor};
}
.canvas{
    display: grid;
    min-height: 100vh;
    grid-auto-flow: row;
    gap:0.5rem;
    text-align:center;
    align-items:center;
    width:100%;
}
.type-box{
    max-width:1000px;
    height:140px;
    margin-left:auto;
    margin-right:auto;
    overflow:hidden;
}
.words-wrapper{
    display:flex;
    flex-wrap:wrap;
    font-size:30px;
}
.word{
    margin:5px;
    padding-right:2px;
}
.hidden-input{
    opacity:0;
}
.correct{
    color:green;
}
.incorrect{
    color:red;
}
.skipped{
    color:gray;
}
.current{
    border-left: 1px solid;
    animation: blinking 2s infinite;
    @keyframes blinking{
        0% {border-left-color:white;}
        25% {border-left-color:black;}
        50% {border-left-color:white;}
        75% {border-left-color:black;}
        100% {border-left-color:white;}
    }
}

.current-right{
    border-right: 1px solid;
    animation: blinkingRight 2s infinite;
    @keyframes blinkingRight{
        0% {border-right-color:white;}
        25% {border-right-color:black;}
        50% {border-right-color:white;}
        75% {border-right-color:black;}
        100% {border-right-color:white;}
    }
}
.upper-menu{
    display:flex;
    width:1000px;
    margin-left:70%;
    margin-right:auto;
    justify-content:space-between;
    font-size:1.4rem;
}
.modes{
    display:flex;
    justify-content:space-between;
    gap:7px;
}
.time-modes:hover{
    color:green;
    cursor:pointer;
    
}
.stats-box{
    display:flex;
    width:1000px;
    margin-left:auto;
    margin-right:auto;
}
.left{
    width:30%;
    
}
.right{
    70%;
}
.Restart{
    cursor:pointer;
    background:white;
    padding-right:19%;
    padding-left:5%;
    margin-left:30%;
    width:10%;
    margin-top:10%;
    font-size:1.5rem;
}
.title{
    font-size:25px;
}
.subtitle{
    font-size:30px;
    color:gold;
}
.header,.footer{
    display:flex;
    justify-content:space-between;
    width:1000px;
    margin-left:auto;
    margin-right:auto;
}
.screen-center{
    display:flex;
    min-height:100vh;
    justify-content:center;
    align-items:center;
    text-align:center;
    font-size:5rem;
}
.table,.user-page-graph{
    width:1000px;
    margin:auto;
}
.table-name{
    color:yellow;
    font-size:2rem;
}

.back{
  background-color: yellow;
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: black;
  margin-top:20%;
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 0;
  outline: none;
  padding: 10px 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.back:hover,
.back:focus {
  background-color: green;
}
.user-info{
    width:1000px;
    margin:auto;
    display-flex;
    background:${({theme})=>theme.titleColor};
    min-height:10rem;
    color:${({theme})=>theme.background};
    border-radius:20px;
}
`

